import React from 'react';
import { Container, Button } from 'react-bootstrap';
import parse from 'html-react-parser';
import useTranslate from 'hooks/useTranslate';
import { usePopularJobsQuery } from 'services';
import JobCard from './JobCard';
import { dataLimits } from 'constants';
import { useNavigate } from 'react-router-dom';
import useAuthStore from 'store/auth';
import { isCompany } from 'utils';
import { setModalConfig } from 'store/common';
import './styles.scss';

const PopularJobs: React.FC = () => {
	const { translate } = useTranslate();
	const navigate = useNavigate();
	const { data: { popularJobs = [] } = [] } = usePopularJobsQuery(
		`limit=${dataLimits?.homePopularJobs}`,
	);

	const authUser: any = useAuthStore((state) => state.userInfo.user);

	const handleClick = (id: number | null = null) => {
		if (!authUser?.userId) {
			setModalConfig({
				visible: true,
				type: 'loginModal',
			});
			return;
		}
		navigate(`/seeker/popular-jobs`);
	};

	return popularJobs?.length > 0 ? (
		<section className="popular-jobs py-80">
			<Container>
				<div className="popular-jobs-head d-flex align-items-center justify-content-between gap-3">
					<div className="main-heading flex-1">
						<h4 className="mb-0 text-uppercase">{translate('Common.trending')}</h4>
						<h2 className="fw-bold mb-0">{parse(translate('Common.popularJobs'))}</h2>
					</div>
					{!isCompany() && (
						<Button className="filled-btn rounded-pill" onClick={() => handleClick()}>
							{translate('Common.viewAll')}
						</Button>
					)}
				</div>

				<div className="popular-jobs-list d-flex flex-wrap">
					{popularJobs?.length > 0 &&
						popularJobs?.map((job: any, index: number) => {
							return <JobCard key={index} job={job} />;
						})}
				</div>
			</Container>
		</section>
	) : (
		<></>
	);
};

export default PopularJobs;
